import BarekamButton from "./barekam-button";

export default BarekamButton;

export enum SimpleButtons {
  LINK = "link",
  TEXT = "text",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
}

export enum HeaderButtons {
  SIMPLE = "simple",
  HEADER_MY_ADDRESSES = "header-my-addresses",
  HEADER_MY_ADDRESSES_COPY = "header-my-addresses-copy",
}

export enum SidebarButtons {
  ITEM = "sidebar-state",
  DASHBOARD = "sidebar-dashboard",
}

export enum AuthButtons {
  MAIN = "auth-action",
  TYPE_SELECT = "auth-type-select",
}

export enum RecipientButtons {
  RECIPIENT_EDIT = "recipient-edit",
}

export enum DialogButtons {
  CANCEL = "dialog-cancel",
  SAVE = "dialog-add",
  DELETE = "dialog-delete",
  OK = "dialog-ok",
}

export enum AddressCardButtons {
  NEW_ADDRESS_ADD = "new-address-add",
}

export enum BalanceButtons {
  NEW_CARD = "new-card",
}

export enum MonthlyLimitsButtons {
  REMOVE = "monthly-limits-remove",
  SET = "monthly-limits-set",
}

export enum OrderButtons {
  ORDER_SUMMARY = "order-summary",
  PAY_NOW = "order-pay-now",
  EXPORT = "order-export",
  ADD_PRODUCT = "add-product",
  WAREHOUSE_CARD = "warehouse_card",
}

export enum FilterButtons {
  MAIN_BUTTON = "filter-main",
  SECONDARY_BUTTON = "filter-secondary",
  CHIP_CLEAR_ALL = "chip-clear-all",
}

export enum CalendarButtons {
  FILTER = "calendar-filter",
}

export enum ParcelEditButtons {
  CANCEL = "parcel-edit-cancel",
  REMOVE = "parcel-edit-remove",
  TO_ANOTHER_ORDER = "parcel-edit-to-another-order",
  NEW_ORDER = "parcel-edit-new-order",
  ADD_DESCRIPTION = "add-description",
}

export enum AdditionalServiceButtons {
  CHOOSE = "additional-service-choose",
  PROCEED = "additional-service-proceed",
}

export enum ActionbarButtons {
  SAVE = "save-order",
  NEW = "new-order",
}

export enum CalculateButtons {
  CALCULATE = "calculate",
}

export enum NewHomeButtons {
  GREEN = "green",
  WHITE = "white",
}
